import { InvestorAccountModel } from '@common/models/InvestorAccountModel';
import * as types from '@services/appsync/types';
import api from './api';
import session from './session';

export type Permission = 'REGISTERED' | 'UNACCREDITED_INVESTOR' | 'ACCREDITED_INVESTOR' | 'FUND_MANAGER';

async function getPermissions() {
  const investorID = session.get()?.investorId;
  const permissions: Permission[] = [];
  if (!investorID) permissions.push('REGISTERED');
  if (investorID) {
    let investorAccount = InvestorAccountModel.getState().investorAccount;
    if (!investorAccount) {
      investorAccount = await api.getInvestorAccount({ id: investorID });
      InvestorAccountModel.setState({ investorAccount });
    }

    const isAccredited = investorAccount?.accreditation?.status === types.AccreditationStatus.APPROVED;
    permissions.push(isAccredited ? 'ACCREDITED_INVESTOR' : 'UNACCREDITED_INVESTOR');
  }
  return permissions;
}

async function hasSomePermissions(permissions: Permission[]) {
  const userPermissions = await getPermissions();
  return permissions.some((permission) => userPermissions.includes(permission));
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    hasSomePermissions,
  };
})();
